import { ALPHABETIC_REGEX } from "@lib/constants";
import DOMPurify from "dompurify";
export const capitalizeFirstLetter = string => {
  return string.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
};
export const capitalizeOnlyFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
export const concatAllString = function (separator) {
  for (var _len = arguments.length, strings = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    strings[_key - 1] = arguments[_key];
  }
  return strings.filter(str => str).join(separator);
};

/**
 * Utility function to get the first or last part of a string separated by a space
 * Use cases are for example to get the first name or last name of a full name
 * @param string Full string
 * @param first is first or last
 * @param separator separator
 * @returns
 */
export const separateStringData = function (str, first) {
  let separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';
  if (!str) return str;
  const stringArray = str.split(separator);
  const items = first ? stringArray.slice(0, 1) : stringArray.slice(1, stringArray.length);
  return concatAllString(separator, ...items);
};

/**
 * Tells if a string is alphanumeric
 * @param text
 * @returns boolean - if the string is alphanumeric or not
 */
export const isAlphanumericString = text => {
  // Check if the text is only numeric
  return /^[a-zA-Z0-9\s]*$/.test(text);
};
export const isNumericString = text => {
  return /^[0-9\s]*$/.test(text);
};

/**
 * Tells if a string is alphabetic
 * @param text
 * @returns boolean - if the string is alphanumeric or not
 */
export const isAlphabeticField = text => {
  // Check if the text is only alphabetic
  return ALPHABETIC_REGEX.test(text);
};
export const isHtml = str => {
  const pattern = /<\/?[a-z][\s\S]*>/i;
  return pattern.test(str);
};
export const sanitizeHTML = html => ({
  __html: DOMPurify.sanitize(html)
});
export const handleLineBreaks = text => text.split("\n");

// Helper function to ensure URLs don't exceed max length
export const validateRedirectUrl = function (url) {
  let maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  if (!url) return '';
  if (url.length <= maxLength) return url;
  const urlObj = new URL(url);
  const baseUrl = "".concat(urlObj.protocol, "//").concat(urlObj.host).concat(urlObj.pathname);
  if (baseUrl.length >= maxLength) {
    return baseUrl.substring(0, maxLength - 5) + '...';
  }
  const essentialParams = ['id', 'orderId', 'success'];
  const searchParams = new URLSearchParams();
  essentialParams.forEach(param => {
    if (urlObj.searchParams.has(param)) {
      searchParams.append(param, urlObj.searchParams.get(param) || '');
    }
  });
  const newUrl = "".concat(baseUrl).concat(searchParams.toString() ? '?' + searchParams.toString() : '');
  if (newUrl.length <= maxLength) {
    return newUrl;
  }
  return baseUrl;
};

/**
 * Creates a URL by combining origin, locale, and provided path segments
 * @param url - The path segments to append (e.g., 'millasbenefit/millonarios')
 * @param defaultUrl - Fallback URL if window is not available (SSR)
 * @param pathname - Current pathname to extract locale from
 * @returns Constructed URL
 */
export const createUrl = (url, defaultUrl, pathname) => {
  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    if (pathname) {
      const pathParts = pathname.split('/').filter(part => part !== '');
      const locale = pathParts[0] || 'es';
      return "".concat(origin, "/").concat(locale, "/").concat(url);
    }
    return "".concat(origin, "/").concat(url);
  }
  return defaultUrl;
};
export const getCountryName = function (countryCode) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  try {
    const regionNames = new Intl.DisplayNames([locale], {
      type: 'region'
    });
    return regionNames.of(countryCode.toUpperCase());
  } catch (e) {
    return countryCode;
  }
};
export const getFirstPartP = htmlString => {
  if (!htmlString) return '';
  const firstPMatch = htmlString.match(/<p[^>]*>(.*?)<\/p>/i);
  if (firstPMatch && firstPMatch[1]) {
    return firstPMatch[1].replace(/<[^>]*>/g, '').trim();
  }
  return '';
};
export const getStringByLocale = (locale, string_en, string_es) => {
  if (!string_en || !string_es) return '';
  if (locale === 'es') return string_es;
  return string_en;
};